import { DefaultValues } from "react-hook-form";

import {
  AdminRegisterFormValues,
  RegisterFormValues,
  VerifyTokenData,
} from "../types";

export const registerAccountDefaultValues: DefaultValues<RegisterFormValues> = {
  confirmPassword: "",
  user: {
    firstName: "",
    lastName: "",
    password: "",
    profilePicture: null,
  },
  profile: {
    honorific: undefined,
    city: "",
    country: undefined,
    jobTitle: "",
    department: "",
    areasOfExpertise: [],
  },
  token: "",
};

export const adminInviteRegisterDefaultValues: DefaultValues<AdminRegisterFormValues> =
  {
    ...registerAccountDefaultValues,
    organization: {
      country: undefined,
      address: "",
      phoneNumber: "",
      email: "",
      invites: [],
    },
  };

export const buildAccountResetValues = (
  data: VerifyTokenData,
  token: string,
): DefaultValues<RegisterFormValues> => ({
  user: {
    firstName: data.firstName,
    lastName: data.lastName,
  },
  token,
});

export const buildAdminInviteResetValues = (
  data: VerifyTokenData,
  token: string,
): DefaultValues<AdminRegisterFormValues> => ({
  ...buildAccountResetValues(data, token),
  ...(data.organization
    ? {
        organization: {
          country: data.organization.country,
          address: data.organization.address,
          phoneNumber: data.organization.phoneNumber,
          email: data.organization.email,
        },
      }
    : {}),
  token,
});
